import SectionHeading from "./SectionHeading";
import { keyQuestions } from "@/mocks/home";

export default function KeyQuestions() {
  return (
    <section id="questions" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <SectionHeading
                eyebrow="核心问题"
                title="投稿前，大家最想知道的四件事"
                desc="这四个问题占了投稿咨询的绝大多数。先把答案放在这里，看完再决定要不要提交。"
              />
              <div className="mt-8 p-5 rounded-lg bg-accent-50 border border-accent-200">
                <div className="flex items-center gap-2 text-accent-700 font-medium text-sm">
                  <i className="ri-alert-line text-lg"></i>
                  重要提醒
                </div>
                <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                  任何以“押金”“手续费”“加急发布费”名义要求转账的行为，都与我们无关，请勿付款。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 flex flex-col gap-5 md:gap-6">
            {keyQuestions.map((item) => (
              <article
                key={item.id}
                id={item.id}
                className="p-6 md:p-8 rounded-lg bg-background-100 border border-background-200 scroll-mt-28"
              >
                <div className="flex items-start gap-4">
                  <span className="w-12 h-12 shrink-0 rounded-md flex items-center justify-center bg-primary-500 text-background-50">
                    <i className={`${item.icon} text-2xl`}></i>
                  </span>
                  <div className="min-w-0">
                    <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm md:text-base text-primary-800 font-medium leading-relaxed">
                      {item.summary}
                    </p>
                  </div>
                </div>

                <ul className="mt-5 space-y-3">
                  {item.points.map((point) => (
                    <li key={point} className="flex items-start gap-3 text-sm text-foreground-700 leading-relaxed">
                      <i className="ri-checkbox-circle-fill text-secondary-500 mt-0.5 shrink-0"></i>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>

                <p className="mt-5 pt-4 border-t border-background-200 text-xs md:text-sm text-secondary-700 flex items-start gap-2">
                  <i className="ri-lightbulb-flash-line text-accent-500 mt-0.5 shrink-0"></i>
                  {item.note}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}